"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _quarkCore = require("quark-core");

var _View = _interopRequireDefault(require("react-native-web/dist/exports/View"));

var _Animated = _interopRequireDefault(require("react-native-web/dist/exports/Animated"));

var _TouchableWithoutFeedback = _interopRequireDefault(require("react-native-web/dist/exports/TouchableWithoutFeedback"));

var _styles = _interopRequireDefault(require("./styles"));

var _duration = _interopRequireDefault(require("./duration"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseAlert =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BaseAlert, _React$Component);

  function BaseAlert() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, BaseAlert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = BaseAlert.__proto__ || Object.getPrototypeOf(BaseAlert)).call.apply(_ref, [this].concat(args))), _this.state = {
      opacity: new _Animated.default.Value(0),
      marginTop: new _Animated.default.Value(-16),
      timeout: null
    }, _this._dismiss = function () {
      // clear the dismiss timeout
      if (_this.state.timeout) {
        clearTimeout(_this.state.timeout);
      } // start the animation


      _Animated.default.parallel([_Animated.default.timing(_this.state.opacity, {
        toValue: 0,
        duration: 250
      }), _Animated.default.timing(_this.state.marginTop, {
        toValue: -16,
        duration: 250
      })]).start(_this.props.onDismiss);
    }, _temp));
  }

  _createClass(BaseAlert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // start the animation
      _Animated.default.parallel([_Animated.default.timing(this.state.opacity, {
        toValue: 1,
        duration: 250
      }), _Animated.default.timing(this.state.marginTop, {
        toValue: 0,
        duration: 250
      })]).start(); // if the alert is dismissable


      if (this.props.dismissable) {
        // save a timeout that dismisses the alert
        this.setState({
          timeout: setTimeout(this._dismiss, this._delay)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          icon = _props.icon,
          content = _props.content,
          iconStyle = _props.iconStyle,
          message = _props.message,
          messageStyle = _props.messageStyle,
          style = _props.style,
          dismissable = _props.dismissable,
          unused = _objectWithoutProperties(_props, ["icon", "content", "iconStyle", "message", "messageStyle", "style", "dismissable"]); // clean up unused props


      Reflect.deleteProperty(unused, 'onDismiss'); // the icon associated with the alert

      var alertIcon = icon || React.createElement(_quarkCore.IconInfo, null);
      return React.createElement(_quarkCore.GetTheme, null, function (_ref2) {
        var blue = _ref2.blue;
        return React.createElement(_Animated.default.View, _extends({
          style: _extends({
            backgroundColor: blue,
            opacity: _this2.state.opacity,
            marginTop: _this2.state.marginTop
          }, _styles.default.container, style)
        }, unused), React.createElement("div", {
          onMouseEnter: function onMouseEnter() {
            if (_this2.state.timeout) {
              clearTimeout(_this2.state.timeout);
            }

            _this2.setState({
              timeout: null
            });
          },
          onMouseLeave: function onMouseLeave() {
            if (_this2.props.dismissable) {
              _this2.setState({
                timeout: setTimeout(_this2._dismiss, _this2._delay)
              });
            }
          },
          style: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            height: '100%'
          }
        }, React.createElement("div", {
          style: {
            marginRight: 20
          }
        }, React.cloneElement(alertIcon, {
          style: _styles.default.iconContainer
        })), React.createElement(_quarkCore.FlexRow, {
          alignItems: "center",
          grow: 1,
          shrink: 1,
          style: _styles.default.contentContainer
        }, React.createElement("span", {
          ref: function ref(ele) {
            return _this2._content = ele;
          }
        }, message ? React.createElement(_quarkCore.Text, {
          style: _extends({}, _styles.default.messageStyle, messageStyle)
        }, message) : content)), React.createElement("div", {
          onClick: _this2._dismiss
        }, React.createElement(_quarkCore.IconX, {
          style: _styles.default.closeIcon
        }))));
      });
    }
  }, {
    key: "_delay",
    get: function get() {
      return this.props.duration || (0, _duration.default)(this._content.textContent);
    }
  }]);

  return BaseAlert;
}(React.Component);

BaseAlert.defaultProps = {
  dismissable: true
};
var _default = BaseAlert;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/alerts/BaseAlert/index.js
// module id = ./node_modules/quark-web/components/alerts/BaseAlert/index.js
// module chunks = 0